export default __webpack_public_path__ + "static/media/FB_MessengerAddOrRemovePage.d1fa938c.png";